// ============================================================================
// PairsForm — useIsMobile : L'idiome responsive canonique (plan R0.1)
// ============================================================================
// `useMediaQuery(theme.breakpoints.down("md"))` existait recopié à l'identique
// dans 11 fichiers (audit 2026-08-23). Une seule source désormais — même
// esprit que `utils/fetch-borne` côté serveur. Le breakpoint de bascule est
// `md` (900 px), ALIGNÉ sur le shell (`ProtectedLayout` : sidebar ↔
// bottom-nav) : un écran qui bascule à un autre seuil que le shell crée des
// états hybrides (bottom-nav affichée mais layout desktop).
//
// Cf. docs/plans/PLAN_RESPONSIVE_MOBILE.md §2 (doctrine par PR).

import { useMediaQuery, useTheme } from "@mui/material";

export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}
